// The Clipboard API is blocked in cross-origin iframes (the website embed); execCommand still works there.
export const copyText = async (text: string): Promise<void> => {
  try {
    await navigator.clipboard.writeText(text);
  } catch {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    const isCopied = document.execCommand('copy');
    textarea.remove();
    if (!isCopied) throw new Error('Copy to clipboard failed');
  }
};
